module.exports = __webpack_public_path__ + "static/media/brVideo2.52ecf7f5.mp4";